/**
 * Okthx on the App Store, for links from the web and the app. Files that can't
 * import it keep their own copy: web/index.html and native/eas.json.
 */
export const APP_STORE_ID = "6745571425";

export const APP_STORE_URL = `https://apps.apple.com/us/app/okthx/id${APP_STORE_ID}`;
